/** @jsxImportSource theme-ui */

import React from 'react';
import { Heading as ThemeUIHeading, HeadingProps as ThemeUIHeadingProps } from 'theme-ui';
import { PaddingProps, StackProps } from '../utils/types';

interface VariantProps {
    variant?: 'dark' | 'accent' | 'primary' | 'secondary';
}
export interface HeadingProps
    extends StackProps,
        PaddingProps,
        Omit<ThemeUIHeadingProps, 'padding' | 'variant' | 'css'>,
        VariantProps {}

function Heading(props: HeadingProps): JSX.Element {
    const { stack, variant, padding, paddingLeftRight, paddingTopBottom, ...otherProps } = props;

    return (
        <ThemeUIHeading
            as={props.as}
            sx={{
                variant: `styles.${props.as}${variant ? `-${variant}` : ''}`,
                padding,
                paddingLeft: paddingLeftRight,
                paddingRight: paddingLeftRight,
                paddingTop: paddingTopBottom,
                paddingBottom: paddingTopBottom,
                marginBottom: stack,
                ...(props.sx || {}),
            }}
            {...otherProps}
        />
    );
}
Heading.defaultProps = {
    stack: 'none',
    padding: 'none',
};
export const H1 = (props: HeadingProps): JSX.Element => <Heading {...props} as="h1" />;
H1.displayName = 'H1';

export const H2 = (props: HeadingProps): JSX.Element => <Heading {...props} as="h2" />;
H2.displayName = 'H2';

export const H2Library = (props: HeadingProps): JSX.Element => (
    <Heading
        {...props}
        as="h2"
        sx={{
            lineHeight: 1.3,
            fontWeight: 'normal',
            fontSize: 'huge',
        }}
    />
);
H2Library.displayName = 'H2Library'; // This won't be in the library for the stable release

export const H3 = (props: HeadingProps): JSX.Element => <Heading {...props} as="h3" />;
H3.displayName = 'H3';

export const H4 = (props: HeadingProps): JSX.Element => <Heading {...props} as="h4" />;
H4.displayName = 'H4';

export const H5 = (props: HeadingProps): JSX.Element => <Heading {...props} as="h5" />;
H5.displayName = 'H5';
